// $('#filter-toggle').sidr({
//   name: 'sidr-filter',
//   source: '#filter',
//   renaming: false,
//   displace: false,
//   onOpen: function () {
//     $('.overlay').css('z-index', '1030');
//     $('.overlay').fadeIn('fast');
//   },
//   onClose: function () {
//     $('.overlay').fadeOut('fast');
//     $('.overlay').css('z-index', '');
//   }
// });

$('#filter-toggle').on('click', function(e){
  e.preventDefault();
  $('.filters-col').addClass('filter-active');
  Livewire.emit('openFilters')
})
